<template>
  <section class="container mx-auto flex max-w-screen-xl p-6 md:p-12 flex-col">
    <VcTypography tag="h2" class="mb-6">
      {{ title }}
    </VcTypography>

    <div class="grid grid-cols-1 md:grid-cols-4 gap-y-4 gap-x-6 md:gap-y-0">
      <div
        v-for="(item, index) in promotionItems"
        :key="index"
        class="rounded-2xl overflow-hidden flex flex-col justify-between relative bg-cover bg-center bg-no-repeat"
        :class="[itemClass(index)]"
        :style="item.image ? { backgroundImage: `url(${item.image})` } : {}"
      >
        <div class="absolute inset-0 flex flex-col p-6">
          <p v-if="item.subtitle" class="text-sm font-light text-white">
            {{ item.subtitle }}
          </p>
          <h3 v-if="item.title" class="text-2xl md:text-3xl font-bold leading-tight text-white">
            {{ item.title }}
          </h3>
        </div>

        <div v-if="item.buttonLabel && item.link" class="p-4 relative z-10 mt-auto">
          <VcButton :to="item.link" class="w-full border border-neutral-500 font-bold" variant="outlined">
            {{ item.buttonLabel }}
          </VcButton>
        </div>

        <div v-else-if="item.link" class="p-4 relative z-10 mt-auto">
          <VcButton
            :to="item.link"
            class="border flex items-center justify-center bg-danger-500 border-danger-500 w-fit"
          >
            <VcIcon class="fill-white relative left-1" name="chevron-right-small" size="sm" />
          </VcButton>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
export interface PromotionItem {
  title: string;
  subtitle?: string;
  buttonLabel?: string;
  link?: string;
  image?: string;
}

export interface IProps {
  title: string;
  promotionItems: PromotionItem[];
}

const props = defineProps<IProps>();

const itemClass = (index: number) => {
  if (index === 1) {
    return "md:col-span-2 md:row-span-2 min-h-[350px] md:min-h-[480px]";
  }
  return "min-h-[350px] md:min-h-[480px]";
};
</script>
